
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"39","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.001 12.21v16.281a6.16 6.16 0 01-1.757 4.317A5.948 5.948 0 0116 34.596h-4.34a6.084 6.084 0 01-2.622 3.233 5.914 5.914 0 01-4.052.752 5.979 5.979 0 01-3.574-2.083A6.172 6.172 0 010 32.561c0-1.44.5-2.835 1.413-3.936a5.979 5.979 0 013.574-2.083 5.915 5.915 0 014.052.752 6.084 6.084 0 012.622 3.232h4.34c.53 0 1.04-.214 1.414-.596.375-.381.586-.899.586-1.439v-16.28a6.16 6.16 0 011.757-4.318 5.948 5.948 0 014.243-1.788h6V0l10 8.14-10 8.14v-6.105h-6c-.53 0-1.04.215-1.414.596-.375.382-.586.9-.586 1.44zm-16 22.386c.53 0 1.04-.214 1.414-.596.375-.381.586-.899.586-1.439s-.21-1.057-.586-1.439a1.983 1.983 0 00-1.414-.596c-.53 0-1.04.215-1.414.596-.375.382-.586.9-.586 1.44 0 .54.21 1.057.586 1.438.375.382.884.596 1.414.596z","fill":"currentColor"}})])
          )
        }
      }
    